import type { ButtonColor } from './colors';

export const primaryColors: Partial<Record<ButtonColor, string>> = {
  'brand-primary': 'bg-primary text-primary-foreground hover:bg-brand-primary-800',
  'brand-secondary': 'bg-brand-secondary-700 text-text-primary-inverse hover:bg-brand-secondary-800',
  white:
    'bg-card font-semibold text-brand-primary-700 focus-visible:ring-white focus-visible:ring-offset-black hover:bg-surface-veil-90',
  destructive: 'bg-destructive text-red-50 hover:bg-red-600',
};
